import { marked } from 'marked';
import { sanitize } from 'dompurify';
export function markdown(text, trusted = false) {
    return trusted ? marked(text) : sanitize(marked(text));
}
